export const goodsPropName = (goods: any): any =>
  goods.productType === 1
    ? goods.productPropertiesName
      .split(';')
      .map((prop: any) => prop.replace(/\d+:\d+:/, ''))
    : [goods.productPropertiesName]

export const blankBar = (function () {
  const fn = (item: any) => {
    if (!item) return
    Object.entries(item).forEach(([k, v]) => {
      if (v === '' || v === null) {
        item[k] = '-'
      } else if (Array.isArray(v)) {
        v.forEach((item) => fn(item))
      } else if (v !== null && typeof v === 'object') {
        fn(v)
      }
    })
  }
  return (data: any): any => {
    Array.isArray(data) ? data.forEach((item) => fn(item)) : fn(data)
    console.log(data)
  }
})()

/* eslint-disable */
Promise.prototype.format = function (fn?: any) {
  return this.then((res) => {
    if (res && res.success) {
      fn && fn(res.data)
    }
    return res
  })
}
